import stylesButtonBase from '@fukku/button/Base/ButtonBase.module.css'
import styles from '@fukku/button/Inspirational/ButtonInspirational.module.css'
import {
	BUTTON_INSPIRATIONAL_STATE,
	BUTTON_INSPIRATIONAL_VARIANT,
	type InspirationalExtraProps,
	LINK_SIZE,
	linkInspirationalSizeStyles,
	stateStyles,
} from '@fukku/button/Inspirational/constants'
import { cx } from 'classix'
import { ButtonBase } from '../Base/ButtonBase'

type ButtonInspirationalProps = Omit<
	React.ComponentProps<'button'>,
	'disabled'
> &
	InspirationalExtraProps

export function ButtonInspirational(
	props: ButtonInspirationalProps
): React.ReactNode {
	const {
		children,
		state = BUTTON_INSPIRATIONAL_STATE.DEFAULT,
		variant = BUTTON_INSPIRATIONAL_VARIANT.DEFAULT,
		size = LINK_SIZE.M,
		className,
		...rest
	} = props

	return (
		<ButtonBase
			{...rest}
			className={cx(
				className,
				styles.buttonInspirational,
				styles[variant],
				linkInspirationalSizeStyles[size],
				stateStyles[state],
				stylesButtonBase.button
			)}
			disabled={state === BUTTON_INSPIRATIONAL_STATE.DISABLED}
		>
			<span className={styles.text}>{children}</span>
		</ButtonBase>
	)
}
